import React, { Component } from "react";
import { connect } from "react-redux";
import { getProductoAdmin } from "../actions";
import { guardaCustomData, guardaProducto, uploadImgProducto } from "../actions/admin";

import AdminMenu from "../components/admin_menu";
import Switch from "../components/switch";
import CustomForm from "../containers/admin_custom_form";

class ProdForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      alert: "",
      respuesta: "",
      descripcion: "",
      estado: 1,
      nombre: "",
      stock: 1,
      cant: 0,
      min: 0,
      etiqueta: "",
      venta_online: true,
      orden: 0,
      custom: 1,
      printArea: null,
      submit:false,
      file:null
    };

    this.enviaDatos = this.enviaDatos.bind(this);
    this.enviaDatosCustom = this.enviaDatosCustom.bind(this);
    this.cambia = this.cambia.bind(this);
    this.switchHandle = this.switchHandle.bind(this);
    this.validaForm = this.validaForm.bind(this);
    this.validaFormCustom = this.validaFormCustom.bind(this);
    this.categoriaChange = this.categoriaChange.bind(this);
    this.uploadImg = this.uploadImg.bind(this);
  }

  componentDidMount() {
    if (!this.props.usuario.user) {
      this.props.history.push("/login");
    }
    if (this.props.match.params.id) {
      this.props.getProductoAdmin(this.props.match.params.id);
    }else{
      this.setState({loading:false})
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.productos.contador < this.props.productos.contador) {
      if(this.state.submit){
        this.props.history.push("/admin/productos");
      }
      var datos = this.props.productos.prod;
      datos.loading = false;
      datos.cant = this.props.productos.prod.unicad.cant;
      datos.min = this.props.productos.prod.unicad.min;
      datos.etiqueta = this.props.productos.prod.unicad.etiqueta;
      datos.id_categoria = this.props.productos.prod.categoria.id;
      if (this.props.productos.prod.hasOwnProperty("custom_data")) {
        console.log(this.props.productos.prod.custom_data);
        datos.printArea = this.props.productos.prod.custom_data;
      }
      if (this.props.productos.prod.hasOwnProperty("img")) {
        datos.img = this.props.productos.prod.img;
      }
      this.setState(datos);
    }
  }

  enviaDatos = e => {
    e.preventDefault();
    this.setState({ loading: true, submit:true }, () => {
     const valida = this.validaForm();
     if (valida.resp) {
        const prodSend = {
          descripcion: this.state.descripcion,
          estado: this.state.estado,
          nombre: this.state.nombre,
          stock: this.state.stock,
          unicad:{
            cant: parseInt(this.state.cant), 
            etiqueta: this.state.etiqueta, 
            min: parseInt(this.state.min) 
          },
          venta_online: this.state.venta_online,
          orden: parseInt(this.state.orden),
          custom: this.state.custom,
          categoria:this.state.categoria,
          rubro:this.state.rubro  
        }
        console.log(prodSend)
        if(this.props.match.params.id){
          this.props.guardaProducto(this.props.match.params.id, prodSend)
        }else{
          this.props.guardaProducto(null, prodSend)
        }
      } else {
        this.setState({ alert: valida.msj, loading: false });
      }
    });
  };

  enviaDatosCustom = datos => {
    console.log(datos);
    var validaCustom = this.validaFormCustom(datos)
    if (validaCustom.resp) {
      this.props.guardaCustomData(this.props.match.params.id, datos);
    } else {
      this.setState({ alert: validaCustom.msj, loading: false });
    }
  };

  uploadImg() {
    if (this.state.file) {
      this.setState({ loading: true }, () => {
        this.props.uploadImgProducto(this.props.match.params.id, this.state.img, this.state.file);
      })
    } else {
      console.log("DEBE SELECCIONAR UN ARCHIVO")
    }
  }

  handleChangeProducto = file => {
    this.setState({ file: file });
  };

  validaForm = () => {
    if (this.state.nombre == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR EL NOMBRE"
      };
    } else if (this.state.descripcion == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR LA DESCRIPCION"
      };
    } else {
      return {
        resp: true,
        msj: "PASO LA VALIDACION"
      };
    }
  };

  validaFormCustom = (datos) => {
    if (datos.color_fx == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR EL EFECTO"
      };
    } else if (datos.color_tipo == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR EL TIPO DE IMPRESION"
      };
    } else if (datos.marginLeft == "" || !datos.marginLeft.includes("px") ) {
      return {
        resp: false,
        msj: "DEBE COMPLETAR CORRECTAMENTE EL MARGEN DE LA IZQUIERDA"
      };
    } else if (datos.marginTop == "" || !datos.marginLeft.includes("px") ) {
      return {
        resp: false,
        msj: "DEBE COMPLETAR CORRECTAMENTE EL MARGEN SUPERIOR"
      };
    } else if (datos.height == "" || !datos.marginLeft.includes("px") ) {
      return {
        resp: false,
        msj: "DEBE COMPLETAR LA ALTURA DEL AREA DE IMPRESION"
      };
    } else if (datos.height_cont == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR LA ALTURA DEL CONTENEDOR DE LA IMAGEN"
      };
    } else if (datos.width == "" || !datos.marginLeft.includes("px") ) {
      return {
        resp: false,
        msj: "DEBE COMPLETAR EL ANCHO DEL AREA DE IMPRESION"
      };
    } else if (datos.width_cont == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR EL ANCHO DEL CONTENEDOR DE LA IMAGEN"
      };
    } else {
      return {
        resp: true,
        msj: "PASO LA VALIDACION"
      };
    }
  };

  cambia = (key, value) => {
    this.setState({ [key]: value });
  };

  switchHandle = (campo, valor) => {
    this.setState({ [campo]: valor });
  };
  
  categoriaChange(e){
    const catNew = this.props.productos.categorias.find(cat =>{
      return cat.id == e.target.value
    })
    //console.log(catNew);
    this.setState({
      categoria: {
        id: catNew.id,
        nombre: catNew.nombre,
        orden:catNew.orden
      },
      rubro: {
        id: catNew.rubro.id,
        nombre: catNew.rubro.nombre,
        orden: catNew.orden
      }
    });
  }

  render() {
    
    const categorias = this.props.productos.categorias.map((cat,i)=>{
      return <option value={cat.id} key={i} name={i}>
          {cat.rubro.nombre} | {cat.nombre}
        </option>;
    })

    return <section className="container row mb-5 sombraHead mt-3 clearfix">
        <div className="col-md-4 mb-3">
          <AdminMenu />
        </div>

        <div className="col-md-8 mb-3">
          {this.state.alert != "" && <div className="alert alert-danger" role="alert">
              {this.state.alert}
            </div>}

          <h1 className="display-4">Producto</h1>

          {this.props.match.params.id &&
            <section className="row">
              <div className="col-md-6 mb-3">
                <div className="card" style={{ width: "18rem" }}>
                  <img className="card-img-top" src={
                    "https://firebasestorage.googleapis.com/v0/b/veltonaccesos-113f7.appspot.com/o/productos%2F" +
                    this.state.img +
                    "?alt=media"
                  }
                    alt={this.state.nombre} />
                  <div className="card-body">
                    <h5 className="card-title">IMAGEN</h5>
                    {!this.state.loading &&
                      <div className="row">
                        <input
                          type="file"
                          className="form-control col"
                          id="productoImg"
                          onChange={e => this.handleChangeProducto(e.target.files)}
                        />
                        <button
                          type="submit"
                          className="btn btn-primary"
                          onClick={this.uploadImg}
                        >
                          <i className="fas fa-angle-right" />
                        </button>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </section>
          }

          <form>
            <div className="form-row">
              <div className="col-md-6 mb-3">
                <label>Nombre</label>
                <input type="text" className="form-control" id="nombre" value={this.state.nombre} aria-describedby="emailHelp" placeholder="Ingrese el nombre del producto" onChange={evt => this.cambia("nombre", evt.target.value)} />
              </div>
              <div className="col-md-6 mb-3">
                <label>Categoria</label>
                <select className="form-control" id="categoria" value={this.state.id_categoria} onChange={this.categoriaChange}>
                  <option value="0">SELECCIONAR</option>
                  {categorias}
                </select>
              </div>
            </div>

            <div className="form-row">
              <label>Descripcion</label>
              <textarea className="form-control" id="descripcion" value={this.state.descripcion} rows="5" placeholder="Ingrese la descripcion del producto" onChange={evt => this.cambia("descripcion", evt.target.value)} />
            </div>

            <div className="form-row">
              <div className="col-md-4 mb-3">
                <label>CUSTOM</label>
                <Switch switchAct={this.switchHandle} dato="custom" off_valor={0} on_valor={1} off="NO" on="SI" stat={this.state.custom} />
              </div>
              <div className="col-md-4 mb-3">
                <label>STOCK</label>
                <Switch switchAct={this.switchHandle} dato="stock" off_valor={0} on_valor={1} off="NO HAY" on="HAY" stat={this.state.stock} />
              </div>
              <div className="col-md-4 mb-3">
                <label>ESTADO</label>
                <Switch switchAct={this.switchHandle} dato="estado" off_valor={0} on_valor={1} off="NULO" on="ACTIVO" stat={this.state.estado} />
              </div>
            </div>

            <div className="form-row">
              <div className="col-md-6 mb-3">
                <label>ORDEN</label>
                <input type="number" className="form-control" id="orden" value={this.state.orden} placeholder="Orden" onChange={evt => this.cambia("orden", parseInt(evt.target.value))} />
              </div>
              <div className="col-md-6 mb-3">
                <label>VENTA ONLINE</label>
                <Switch switchAct={this.switchHandle} dato="venta_online" off_valor={0} on_valor={1} off="NO" on="SI" stat={this.state.venta_online} />
              </div>
            </div>

            <div className="form-row">
              <div className="col-md-4 mb-3">
                <label>CANT ETIQUETA</label>
                <input type="text" className="form-control" id="etiqueta" value={this.state.etiqueta} placeholder="Etiqueta de la unidad" onChange={evt => this.cambia("etiqueta", evt.target.value)} />
              </div>
              <div className="col-md-4 mb-3">
                <label>MULTIPLO</label>
                <input type="number" className="form-control" id="cant" value={this.state.cant} onChange={evt => this.cambia("cant", parseInt(evt.target.value))} />
              </div>
              <div className="col-md-4 mb-3">
                <label>CANTIDAD MIN</label>
                <input type="number" className="form-control" id="min" value={this.state.min} placeholder="Cantidad minima" onChange={evt => this.cambia("min", parseInt(evt.target.value))} />
              </div>
            </div>

            {!this.state.loading ? <button type="submit" className="btn btn-primary" onClick={this.enviaDatos}>
                Guardar
              </button> : <h5>AGUARDE UN INSTANTE...</h5>}
          </form>

          {this.props.match.params.id && <CustomForm id_prod={this.props.match.params.id} printArea={this.state.printArea} cambiaAct={this.cambiaArea} enviaAct={this.enviaDatosCustom} stat={this.state.loading} />}
        </div>
      </section>;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    usuario: state.usuario,
    productos: state.productos
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getProductoAdmin: id => {
      dispatch(getProductoAdmin(id));
    },
    guardaProducto: (id_producto, datos) => {
      dispatch(guardaProducto(id_producto, datos));
    },
    guardaCustomData: (id_producto, datos) => {
      dispatch(guardaCustomData(id_producto, datos));
    },
    uploadImgProducto: (id_producto, imgActual, file) => {
      dispatch(uploadImgProducto(id_producto, imgActual, file));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProdForm);



// WEBPACK FOOTER //
// ./src/containers/admin_prod_form.js